/* BELLA v3 — JavaScript */

// ── HEADER SCROLL ──
(function(){
  var h=document.querySelector('.site-header');
  if(!h)return;
  window.addEventListener('scroll',function(){h.classList.toggle('scrolled',window.scrollY>12)},{passive:true});
})();

// ── MOBILE NAV ──
var burger=document.getElementById('BellaBurger');
var mobileNav=document.getElementById('BellaMobileNav');
if(burger&&mobileNav){
  burger.addEventListener('click',function(){
    var open=mobileNav.classList.toggle('open');
    burger.classList.toggle('open',open);
    burger.setAttribute('aria-expanded',open);
  });
}
function bellaMobileToggle(btn){
  var links=btn.nextElementSibling;
  var isOpen=links.classList.contains('open');
  document.querySelectorAll('.mob-links.open').forEach(function(el){
    el.classList.remove('open');
    el.previousElementSibling.classList.remove('open');
  });
  if(!isOpen){links.classList.add('open');btn.classList.add('open');}
}

// ── TOAST ──
function bellaToast(msg,type){
  var el=document.getElementById('toast');
  if(!el)return;
  el.textContent='';
  var icon=document.createElement('span');
  icon.textContent=type==='success'?'✓':'✕';
  icon.style.cssText='font-size:1rem;font-weight:700;color:'+(type==='success'?'#22c55e':'#e8284a');
  var txt=document.createElement('span');
  txt.textContent=msg;
  el.appendChild(icon);el.appendChild(txt);
  el.className='toast '+type;
  requestAnimationFrame(function(){requestAnimationFrame(function(){el.classList.add('show');});});
  clearTimeout(el._t);
  el._t=setTimeout(function(){el.classList.remove('show');},3500);
}

// ── CART SYNC ──
function bellaSyncCart(){
  fetch('/cart.js')
    .then(function(r){return r.json();})
    .then(function(cart){
      // badge
      document.querySelectorAll('.ha-badge').forEach(function(b){
        b.textContent=cart.item_count;
        b.style.display=cart.item_count>0?'flex':'none';
      });
      // drawer items
      var body=document.getElementById('cart-body');
      var items=document.getElementById('cart-items');
      var empty=document.getElementById('cart-empty');
      var foot=document.getElementById('cart-foot');
      var totalEl=document.getElementById('cart-total-price');
      if(!body)return;
      if(cart.item_count===0){
        if(items)items.style.display='none';
        if(empty)empty.style.display='';
        if(foot)foot.style.display='none';
      } else {
        if(empty)empty.style.display='none';
        if(foot)foot.style.display='flex';
        if(items){
          items.style.display='';
          items.innerHTML='';
          cart.items.forEach(function(item){
            var d=document.createElement('div');
            d.className='cart-di';
            d.innerHTML='<img src="'+item.image+'" alt="'+item.title+'" loading="lazy">'
              +'<div class="cart-di__info">'
              +'<div class="cart-di__title">'+item.product_title+'</div>'
              +(item.variant_title&&item.variant_title!=='Default Title'?'<div style="font-size:.75rem;color:var(--fg3);margin:.2rem 0">'+item.variant_title+'</div>':'')
              +'<div class="cart-di__price">'+(item.final_line_price/100).toFixed(2).replace('.',',')+' €</div>'
              +'</div>'
              +'<button class="cart-di__remove" onclick="bellaRemoveItem('+item.key+')" aria-label="Supprimer">✕</button>';
            items.appendChild(d);
          });
        }
        if(totalEl)totalEl.textContent=(cart.total_price/100).toFixed(2).replace('.',',')+' €';
      }
    });
}

function bellaRemoveItem(key){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
    .then(function(){bellaSyncCart();})
    .catch(function(){});
}

function openCart(){
  var d=document.getElementById('cart-drawer');
  if(d){d.classList.add('open');document.body.style.overflow='hidden';}
  bellaSyncCart();
}
function closeCart(){
  var d=document.getElementById('cart-drawer');
  if(d){d.classList.remove('open');document.body.style.overflow='';}
}

// ── ADD TO CART ──
function bellaAddToCart(btn,variantId,qty){
  qty=qty||1;
  if(btn){btn.disabled=true;btn.textContent='...';}
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:variantId,quantity:qty}]})
  })
  .then(function(r){return r.json();})
  .then(function(data){
    if(data.status){bellaToast('Erreur : '+data.description,'error');}
    else{bellaToast('Ajouté au panier !','success');bellaSyncCart();openCart();}
  })
  .catch(function(){bellaToast('Une erreur est survenue','error');})
  .finally(function(){
    if(btn){btn.disabled=false;btn.innerHTML='<svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>Ajouter';}
  });
}

// ── PRODUCT PAGE ──
var _variants=window._bellaVariants||[];
var _qty=1;
var _maxQty=9999;
var _currentVariant=window._bellaCurrentVariant||{};

function bellaQtyChange(delta){
  _qty=Math.max(1,Math.min(_qty+delta,_maxQty));
  var el=document.getElementById('QtyVal');
  if(el)el.textContent=_qty;
  // Visual feedback on buttons
  document.querySelectorAll('.qty-btn').forEach(function(b,i){
    if(i%2===0)b.style.opacity=_qty<=1?'.3':'1';
    else b.style.opacity=_qty>=_maxQty?'.3':'1';
  });
}
function bellaSelectOption(btn,idx){
  var group=btn.closest('.variant-opts');
  group.querySelectorAll('.variant-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
  var opts=[];
  document.querySelectorAll('.variant-opts').forEach(function(g){
    var a=g.querySelector('.variant-btn.active');
    if(a)opts.push(a.dataset.value);
  });
  _variants.forEach(function(v){
    if(v.options.join('|')===opts.join('|')){
      _currentVariant=v;
      var p=document.getElementById('ProductPrice');
      if(p)p.textContent=(v.price/100).toFixed(2).replace('.',',')+' €';
      var atc=document.getElementById('AtcBtn');
      if(atc){
        atc.disabled=!v.available;
        if(!v.available)atc.textContent='Épuisé';
        else atc.innerHTML='<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Ajouter au panier';
      }
      _maxQty=v.inventory_quantity||9999;
      _qty=1;var qe=document.getElementById('QtyVal');if(qe)qe.textContent='1';
      if(v.featured_image)bellaSetGallery(null,v.featured_image.src);
    }
  });
}
function bellaSetGallery(btn,src){
  var main=document.getElementById('GalleryMain');
  if(main)main.src=src;
  document.querySelectorAll('.gallery-thumb').forEach(function(b){b.classList.remove('active');});
  if(btn)btn.classList.add('active');
}
function bellaAtcMain(){
  if(_maxQty<9999&&_qty>_maxQty){bellaToast('Stock limité à '+_maxQty+' unité(s)','error');return;}
  var btn=document.getElementById('AtcBtn');
  bellaAddToCart(btn,_currentVariant.id,_qty);
}

// ── TABS ──
function bellaTab(btn,id){
  document.querySelectorAll('.tab-btn').forEach(function(b){b.classList.remove('active');});
  document.querySelectorAll('.tab-panel').forEach(function(p){p.classList.remove('active');});
  btn.classList.add('active');
  var panel=document.getElementById(id);
  if(panel)panel.classList.add('active');
}

// ── COLORATION NUANCE SELECTOR ──
function bellaSelectNuance(btn){
  document.querySelectorAll('.colo-swatch').forEach(function(s){s.classList.remove('active');});
  btn.classList.add('active');
  var id=parseInt(btn.dataset.variantId);
  var num=btn.dataset.variantNum||'';
  var name=btn.dataset.variantName||'';
  var price=btn.dataset.variantPrice;
  var available=btn.dataset.variantAvailable==='true';
  var qty=parseInt(btn.dataset.variantQty)||0;
  var image=btn.dataset.variantImage;
  var thumb=btn.dataset.variantThumb;
  var variants=window._bellaVariants||[];
  _currentVariant=variants.find(function(v){return v.id===id;})||_currentVariant;
  // Reset qty
  _maxQty=qty>0?qty:0;
  _qty=1;
  var qtyEl=document.getElementById('QtyVal');
  if(qtyEl)qtyEl.textContent='1';
  document.querySelectorAll('.qty-btn').forEach(function(b,i){
    if(i%2===0)b.style.opacity='.3';
    else b.style.opacity=_maxQty<=1?'.3':'1';
  });
  // Update image
  if(image){var main=document.getElementById('GalleryMain');if(main)main.src=image;}
  // Update selected box
  var numEl=document.getElementById('ColoSelectedNum');if(numEl)numEl.textContent=num;
  var nameEl=document.getElementById('ColoSelectedName');if(nameEl)nameEl.textContent=name;
  var selImg=document.getElementById('ColoSelectedImg');if(selImg&&thumb)selImg.src=thumb;
  var stockSel=document.getElementById('ColoSelectedStock');
  if(stockSel){
    if(available){stockSel.textContent=qty+' en stock';stockSel.className='colo-selected__stock'+(qty<=5?' colo-selected__stock--low':'');}
    else{stockSel.textContent='Rupture';stockSel.className='colo-selected__stock colo-selected__stock--oos';}
  }
  // Update price
  var priceEl=document.getElementById('ColoPrice');if(priceEl)priceEl.textContent=price;
  // Update stock
  var stockEl=document.getElementById('ColoStock');
  if(stockEl){
    if(available)stockEl.innerHTML='<span class="colo-stock__dot colo-stock__dot--in"></span> En stock ('+qty+')';
    else stockEl.innerHTML='<span class="colo-stock__dot colo-stock__dot--out"></span> Rupture de stock';
  }
  // Update ATC
  var atcBtn=document.getElementById('AtcBtn');
  if(atcBtn){
    atcBtn.disabled=!available;
    if(available)atcBtn.innerHTML='<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Ajouter au panier';
    else atcBtn.textContent='Produit épuisé';
  }
  if(history.replaceState){var url=new URL(window.location);url.searchParams.set('variant',id);history.replaceState({},'',url);}
}

// ── INIT ──
document.addEventListener('DOMContentLoaded',function(){
  bellaSyncCart();
  // Pick up coloration template vars if present
  if(window._bellaInitVariant){_currentVariant=window._bellaInitVariant;}
  if(window._bellaInitMaxQty){_maxQty=window._bellaInitMaxQty;}
  // Gallery thumbnails
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb,i){
    if(i===0)thumb.classList.add('active');
    thumb.addEventListener('click',function(){
      bellaSetGallery(this,this.dataset.src);
    });
  });
  // Tabs init
  var firstTab=document.querySelector('.tab-btn');
  var firstPanel=document.querySelector('.tab-panel');
  if(firstTab)firstTab.classList.add('active');
  if(firstPanel)firstPanel.classList.add('active');
});
